import React from 'react'
import RCSteps from 'rc-steps'

import Step from './components/step.component'

import { Pages } from '../../types'
import getCurrentStep from './get-current-step'

import stepFinish from './assets/step-finish.svg'
import stepProcess from './assets/step-process.svg'
import stepWait from './assets/step-wait.svg'

import 'rc-steps/assets/index.css'
import 'rc-steps/assets/iconfont.css'
import * as styles from './steps.module.css'

interface StepsProps {
  page: Pages
}

const CustomDot = (_dot: null, { status }: { status: string }) => {
  if (status === 'finish') {
    return <img src={stepFinish} alt="finish" />
  } else if (status === 'process') {
    return <img src={stepProcess} alt="process" />
  } else if (status === 'wait') {
    return <img src={stepWait} alt="wait" />
  } else {
    return <img src={stepWait} alt="wait" />
  }
}

const Steps: React.FC<StepsProps> = ({ page }) => {
  const currentStep = getCurrentStep(page)

  return (
    <div className={styles.stepsContainer} data-testid="steps">
      <div className={styles.steps}>
        {
          <RCSteps progressDot={CustomDot as any} current={currentStep}>
            <Step title={'Car'} />
            <Step title={'Details'} />
            <Step title={'Valuation'} />
          </RCSteps>
        }
      </div>
    </div>
  )
}

export default Steps
